/**
 * ( ! ) IF THE REQUIREMENTS GROW PLEASE CONSIDER REPLACING THIS FUNCTION WITH A PROPER EXTERNAL LIBRARY
 * -----------------------------------------------------------------------------------------------
 * evaluateFormula takes a formula string and an object containing variable names and their corresponding values.
 * It first tokenizes the formula string, converts it to Reverse Polish Notation (RPN), and then evaluates the RPN expression using a stack.
 * Finally, it returns the result of the evaluation.
 *
 *
 * Only +,-,*,/ and numbers are supported.
 *
 * // Example usage:
 * const formula = 'VAL*FAC/100';
 * const variables = { 'VAL': 50, 'FAC': 10 };
 * const result = evaluateFormula(formula, variables);
 * console.log(result); // Output: 5
 *
 * @param formula
 * @param variables
 * @returns {*}
 */
export function evaluateFormula (formula, variables) {
  // Replace variables in the formula with their values
  formula = substituteVariables(variables, formula)

  // Perform arithmetic operations respecting order of operands
  const operatorStack = []
  const operandStack = []

  const precedence = {
    '+': 1,
    '-': 1,
    '*': 2,
    '/': 2
  }

  const tokens = formula.match(/([0-9]*[.])?[0-9]+|\+|-|\*|\//g)

  tokens.forEach(token => {
    if (token.match(/([0-9]*[.])?[0-9]+/)) {
      operandStack.push(parseFloat(token))
    } else {
      while (operatorStack.length > 0 && precedence[operatorStack[operatorStack.length - 1]] >= precedence[token]) {
        const operator = operatorStack.pop()
        const operand2 = operandStack.pop()
        const operand1 = operandStack.pop()
        operandStack.push(applyOperation(operand1, operand2, operator))
      }
      operatorStack.push(token)
    }
  })

  while (operatorStack.length > 0) {
    const operator = operatorStack.pop()
    const operand2 = operandStack.pop()
    const operand1 = operandStack.pop()
    operandStack.push(applyOperation(operand1, operand2, operator))
  }

  return operandStack.pop()
}

function substituteVariables (variables, formula) {
  for (let variable in variables) {
    if (variables.hasOwnProperty(variable)) {
      const regex = new RegExp(variable, 'g')
      formula = formula.replace(regex, variables[variable])
    }
  }
  return formula
}

function applyOperation (operand1, operand2, operator) {
  switch (operator) {
    case '+':
      return operand1 + operand2
    case '-':
      return operand1 - operand2
    case '*':
      return operand1 * operand2
    case '/':
      if (operand2 === 0) {
        throw new Error('Division by zero')
      }
      return operand1 / operand2
    default:
      throw new Error('Invalid operator')
  }
}
